module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row header"
  }, [_c('div', {
    staticClass: "col-md-1 col-xs-1 back",
    on: {
      "click": function($event) {
        return _vm.back()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/back.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.commentTip))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 stars"
  }, [_c('ul', {
    staticClass: "list-inline"
  }, _vm._l((_vm.stars), function(star, index) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.starClicked(index)
        }
      }
    }, [_c('span', {
      class: ['glyphicon', {
        'glyphicon-star': star.active,
        'glyphicon-star-empty': !star.active
      }]
    })])
  }), 0)])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.submitText))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-10 col-xs-10"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/netvue_logo.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d26f4fb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/nvui/activities/Comment.vue
// module id = 146
// module chunks = 1